import i18next from 'i18next';

i18next.addResources('es', 'PJNDeleteFileModal', {
  delete: 'Eliminar',
  cancel: 'Cancelar',
  deleteMessage: 'Está seguro que desea eliminar el expediente?',
  deleteModalTitle: 'Eliminar expediente',
  loadingMessage: 'Eliminando el expediente',
  errorMessage: 'No pudimos eliminar el expediente, por favor vuelva a intentarlo.',
  successMessage: 'Expediente eliminado con éxito.'
});
